/*!*
 * @author yueheqin
 * @date 2019/8/15
 * @project zujuanzaixian
 * @desc 登录之后的操作
 */
import {mapGetters, mapMutations, mapActions} from 'vuex'
import {getLocalItem} from '../utils/storage'
import {Base64Encode} from '../utils'
import {PAPER_CFG, QUES_BASKET_KEY} from '../config'
import {setToken} from '../utils/token'
import {oauthQQLoginApi} from '../api/login'

let qqLoginLoading = false
// 缓存已打开页面
let openedWindow = []
let hasMessageListener = false
const goQQLogin = (cb) => {
  // 打开新窗口前关闭之前打开的窗口
  _.each(openedWindow, (win) => {
    win.close()
  })
  let newwin = window.open('/qqLogin.html', '_blank', 'toolbar=no, directories=no, status=no, menubar=no, width=650, height=500')
  openedWindow.push(newwin)
  if (hasMessageListener) {
    return
  }
  hasMessageListener = true
  window.addEventListener('message', function (e) {
    let data = JSON.parse(e.data)
    if (e.origin === location.origin && data._type === 'qqlogin') {
      cb(data.data)
    }
  })
}

export const loginCBMixin = {
  computed: {
    ...mapGetters('user', ['isLogin'])
  },
  methods: {
    ...mapMutations('common', ['hideLoginDialog']),
    ...mapMutations('user', ['updateIsLogin']),
    ...mapActions('user', ['getUserInfo']),
    ...mapActions('common', ['getCatalogList']),
    ...mapMutations('basket', ['initQuesBasket', 'initPaperCfg', 'updateQuesBasket', 'updatePaperCfg']),
    ...mapActions('basket', ['getSubjectPaperConfig']),
    loginCB (data, isChangeSubject) {
      let vm = this
      if (isChangeSubject) {
        this.updateQuesBasket()
        this.updatePaperCfg()
        vm.getSubjectPaperConfig()
      } else {
        console.log(data.data, data.data['access_token'])
        setToken(data.data['access_token'])
        vm.updateIsLogin(1)
        vm.hideLoginDialog()
        vm.getUserInfo().then(() => {
          vm.getSubjectPaperConfig()
        })
        if (!getLocalItem(PAPER_CFG)) {
          vm.initPaperCfg(vm.subjectList)
        }
        if (!getLocalItem(QUES_BASKET_KEY)) {
          vm.initQuesBasket(vm.subjectList)
        }
      }
      // vm.getSubjectPaperConfig()
      if (vm.isLogin) vm.getCatalogList()
    },
    goQQLogin () {
      goQQLogin(({openid}) => {
        if (!qqLoginLoading) {
          qqLoginLoading = true
          oauthQQLoginApi(openid).then(({data}) => {
            qqLoginLoading = false
            // 关闭登录框
            this.$emit('should-close')
            if (data.status == 0) {
              this.$router.push({name: 'OauthBindAccount', query: {key: Base64Encode({openID: openid, token: getLocalItem('oauth_token')})}})
            } else if (data.status == 1) {
              setToken(data.access_token)
              if (_.includes(['Login', 'Register', 'OauthBindAccount'], this.$route.name)) {
                this.getUserInfo()
                this.$router.replace({name: 'Index'})
              } else {
                location.reload()
              }
            }
          })
        }
      })
    },
    bindQQLogin () {
      this.goQQLogin()
    }
  }
}
